import { isEqual, isObject } from 'lodash';

const setFiltersURL = ({
  searchParams,
  values,
  initialValues = { query: {} },
  ignoredParamsKeys = [],
}) => {
  const newSearchParams = new URLSearchParams(searchParams.toString());

  newSearchParams.forEach((key) => {
    if (!ignoredParamsKeys.includes(key)) {
      newSearchParams.delete(key);
    }
  });

  Object.entries(values.query).forEach(([key, value]) => {
    // Skip null/undefined values - they shouldn't be in the URL
    if (value === null || value === undefined) {
      newSearchParams.delete(key);
      return;
    }

    // Compare submitted values with initial values
    if (!isEqual(values.query[key], initialValues.query[key])) {
      let setValue = value;

      // Transform objects to string
      if (isObject(values.query[key])) {
        setValue = JSON.stringify(value);
      }

      newSearchParams.set(key, setValue);
    } else {
      // Clear param if same as initial value
      newSearchParams.delete(key);
    }
  });

  window.history.pushState(
    null,
    '',
    newSearchParams.toString() !== ''
      ? `?${newSearchParams.toString()}`
      : window.location.pathname,
  );
};

// Apply debounce to optimize
export default setFiltersURL;
